import {
  GetProfileQuery,
  useGetProfileLazyQuery,
  useOnBroadcastAddedSubscription,
  useOnNewsAddedSubscription,
} from '@services/data-access';
import { useAnnouncements, useAuth } from '@hooks';
import { Auth } from '@services/auth';
import { Loading } from '@components/common';
import React from 'react';

export const withAuth = (Component: React.ComponentType<any>) => {
  return (props: any) => {
    const [{ id }, setAuth] = useAuth();
    const [announcements, setAnnouncementCount] = useAnnouncements();
    const [isLoading, setIsLoading] = React.useState<boolean>(false);

    const [getProfile, { loading }] = useGetProfileLazyQuery({
      fetchPolicy: 'network-only',
      onCompleted: (result: GetProfileQuery) => {
        setAuth({ ...result.get_profile[0], isLoggedIn: true });
        setIsLoading(false);
      },
    });

    useOnBroadcastAddedSubscription({
      variables: { id },
      onSubscriptionData: (broadcasts: any) =>
        setAnnouncementCount({
          ...announcements,
          count: {
            ...announcements.count,
            broadcast:
              broadcasts.subscriptionData.data.broadcast_logs_aggregate
                .aggregate.count,
          },
        }),
    });

    useOnNewsAddedSubscription({
      variables: { id },
      onSubscriptionData: (news: any) =>
        setAnnouncementCount({
          ...announcements,
          count: {
            ...announcements.count,
            news: news.subscriptionData.data.news_logs_aggregate.aggregate
              .count,
          },
        }),
    });

    React.useEffect(() => {
      document.title = `Indigo ${
        process.env.NODE_ENV !== 'production' ? `(${process.env.NODE_ENV})` : ''
      }`;
      (async () => {
        try {
          await Auth.currentSession();
          getProfile();
        } catch {
          setIsLoading(false);
        }
      })();
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    if (loading || isLoading) {
      return <Loading />;
    }

    return <Component {...props} />;
  };
};
